

















































import { Component, Vue, Watch } from 'vue-property-decorator'
import PublicQuery from '@/components/PublicQuery/PublicQuery.vue'
import { IFormItem } from '@/components/PublicQuery/PublicQuery'
import Echarts from '@/components/Echarts/Echarts.vue'
import { UserModule } from '../../store/modules/user'
import api from '../../api'
import { formatDate, accMul } from '../../utils/utils'
import { mapActions } from 'vuex'
import { UnitControlTypeMap } from '@/model/const'
import { log } from 'console'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
// import { ElLoading } from 'element-plus'

@Component({
  components: {
    PublicQuery,
    Echarts,
  },
})
export default class StatsElectricChart extends Vue {
  created() {
    this.getEledev()
  }
  private fullscreenLoading:boolean=false
  private noData: boolean = false
    private Datalist: any = ''
  private option: any = {}
  private queryItems: IFormItem[] = [

    {
      label: '选择设备',
      key: 'dev',
      type: 'select',
      options: [

        { label: '98CC4D40142F', value: '98CC4D40142F' },
      ],
    },
    {
      label: '查询日期',
      key: 'date',
      type: 'date',
      placeholder: '选择查询日期',
      clearable: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    },
  ]
  private queryParams = {
    date: formatDate(new Date(), 'YYYY-MM-DD'),
    dev: '',
  }
  private lastDay() {
    var datetTime = new Date(this.queryParams.date)
    const time = datetTime.setDate(datetTime.getDate() - 1)
    this.queryParams.date = this.formatDate1(time)
    this.queryChange()
  }
  private formatJsonAll(list, filterVal) {
    return list.map(v => filterVal.map(j => {
      if (j === 'gmtModified') {
        return parseTime(new Date(v[j]))
      } else {
        return v[j]
      }
    }))
  }
  // 创建一个worksheet,创建过程中设置表头
private createWs(data, fields, titles) {
    const ws = XLSX.utils.json_to_sheet(
        data, 
        { 
            header: fields
        }
    )
    const range = XLSX.utils.decode_range(ws['!ref'])
    
    for(let c = range.s.c; c <= range.e.c; c++) {
      const header = XLSX.utils.encode_col(c) + '1'
      ws[header].v = titles[ ws[header].v ]
    }
    
    return ws
}
 private exportExcel() {
  // let data={

  // }

  // api.exportElectric(

  // )
    /* 从表生成工作簿对象 */
    console.log(this.noData)
       if(this.Datalist==''){
       this.$message.warning('请先生成出图表')
      return
    }

    // 创建工作簿
    const workbook = XLSX.utils.book_new()
       const titles={
      aA:'实时电流',
      aQ:'新增电量',
      aV:'实时电压',
      aW:'实时功率',
      updateTime:'更新时间',
      power:'当前线路累计电量',
      time:'时间'

    }
    const fields=['aA','aQ','aV','aW','updateTime','power','time']

    for (let i = 0; i < this.Datalist.addrs.length; i++) {
      // 创建工作表
      // const worksheet = XLSX.utils.json_to_sheet(this.Datalist.addrs[i].logs
      // )
        const worksheet = this.createWs(this.Datalist.addrs[i].logs,fields,titles
      )

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(workbook, worksheet, this.Datalist.addrs[i].addrName)
    }

    // 将工作簿保存为Excel文件
    XLSX.writeFile(workbook, 'output.xlsx')
    // var wb = XLSX.utils.json_to_sheet(this.Datalist)
    // XLSX.utils.book_append_sheet(workbook, wb, 'Sheet1')

    // /* 获取二进制字符串作为输出 */
    // var wbout = XLSX.write(wb, {
    //   bookType: 'xlsx',
    //   bookSST: true,
    //   type: 'array',
    // })
    // try {
    //   FileSaver.saveAs(
    //     new Blob([wbout], { type: 'application/octet-stream' }),
    //     'sheetjs.xlsx'
    //   )
    // } catch (e) {
    //   if (typeof console !== 'undefined') console.log(e, wbout)
    // }
    // return wbout
  }

  private afterDay() {
    var datetTime = new Date(this.queryParams.date)
    const time = datetTime.setDate(datetTime.getDate() + 1)
    if (time > Date.now()) {
      this.$message.warning('只能查询今天之前的记录')
      return
    }
    this.queryParams.date = this.formatDate1(time)
    this.queryChange()
  }
  private formatDate1(time : any) {
    const t = new Date(time)
    // 日期格式
    let year:any = t.getFullYear()
    // 由于 getMonth 返回值会比正常月份小 1
    let month:any = t.getMonth() + 1
    let day:any = t.getDate()
    month = month > 9 ? month : `0${month}`
    day = day > 9 ? day : `0${day}`
    return year + '-' + month + '-' + day
  }

  private queryChange() {
    const orgId = UserModule.orgInfo.orgId
    // console.log('queryParams' + JSON.stringify(this.queryParams))
    const { date = [], dev = '' } = this.queryParams || {}
    if (!date || !date.length) {
      this.$message.warning('请选择日期')
      return
    }
    if (!dev || !dev.length) {
      this.$message.warning('请选择设备')
      return
    }
    this.getElectricPower(date, 'P00000021419', dev)
  }
  // 获取功率数据
  private getElectricPower(Date:any, projectCode: any, devId: any) {
    var str = Date.split('-')
    var year = str[0]
    var month = str[1]
    var day = str[2]
    var hour = ''
this.fullscreenLoading=true
    api.getElectricBehavior({ devId, Date }).then((datas) => {
      const { addrs = [] }: { addrs: any[] } = datas || {}

      console.log(datas)
      this.Datalist = datas
      this.fullscreenLoading=false
      if (this.noData) return
      this.getPowerEcharts(str, devId, addrs)
    })
  }

  private getPowerEcharts(date:any, mac: any, addrs: any) {
    // console.log(addrs);
    // console.log(addrs.map((item:any) => item.addrName).reverse());

    const addr:any = []
    const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
    const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
    this.option = {
      title: {
        textStyle: {
          color: '#333',
          fontStyle: 'normal',
          fontWeight: '200',
          fontFamily: 'sans-serif',
          fontSize: 15,
        },
        text: date + '日' + mac + '设备行为记录曲线图',
        x: 'center',
        y: 'bottom',
        padding: [100, 0, 0, 0],
      },
      tooltip: {
        trigger: 'axis',
        formatter: function(params: any[]) {
          let result = ''
          result += params.reduceRight((prev, curr, index) => {
            if (index === params.length - 1) {
              prev += `${formatDate(curr.axisValue)}<br>`
            }
            let r = ''

            // console.log(curr);
            if (curr.seriesName.slice(-2) == '累计用电') {
              r = prev += `${curr.marker}${curr.seriesName} ${curr.value[1]} kWh <br>`
            } else {
              r = prev += `${curr.marker}${curr.seriesName} ${curr.value[1]} W <br>`
            }
            // const r = prev += `${curr.marker}${curr.seriesName} ${curr.value[1]} W <br>`
            return r
          }, result)
          return result
        },
      },
      legend: {

        data: addrs.map((item:any) => item.addrName+'实时功率').reverse().concat(addrs.map((item:any) => item.addrName + '累计用电').reverse()),

        itemHeight: 10, // 改变圆圈大小
        icon: 'circle',
        textStyle: {
          fontSize: 14,
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        top: '20%',
        containLabel: true,
      },
      toolbox: {
        feature: {
          dataZoom: {
            yAxisIndex: 'none',
          },
          restore: {},
          saveAsImage: {
            name: '单元分析',
          },
        },
      },
      dataZoom: [
        {
          type: 'inside',
          filterMode: 'none',
          throttle: 50,
        },
      ],
      xAxis: {
        type: 'time',
        splitNumber: 24,
        boundaryGap: true,
        min: minTime,
        max: maxTime,
        splitLine: { // 网格线
          show: false,
        },
        axisLabel: {
          formatter: function(value: any, index: number) {
            // 格式化成月/日，只在第一个刻度显示年份
            if (value % 3600000) {
              return formatDate(value, 'HH:mm:ss')
            } else {
              return formatDate(value, 'HH:mm')
            }
          },
        },
      },
      yAxis: [
        {
          type: 'value',
          name: '实时功率',
          axisLabel: {
            formatter: '{value} W',
          // color: '#27719F',
          },
        },
        {
          type: 'value',
          name: '累计用电',
          axisLabel: {
            formatter: '{value} kwh',
          // color: '#27719F',
          },
        },
      ],
      series: [
        // console.log();

        ...addrs.map((devItem:any, index:any) => {
          const { addrName = '', logs = [] } : { addrName:string, logs: any[] } = devItem || {}
          return {
            name: devItem.addrName+'实时功率' || '',
            type: 'line',
            step: 'end',
            showSymbol: false,
            lineStyle: {
              width: 3,
            },
            data: this.getPower(logs, 0, minTime, maxTime),

          }
        }),
        ...addrs.map((devItem:any, index:any) => {
          const { addrName = '', logs = [] } : { addrName:string, logs: any[] } = devItem || {}
          return {
            name: devItem.addrName + '累计用电' || '',
            type: 'line',

            // step: 'end',
            showSymbol: false,

            yAxisIndex: 1,
            lineStyle: {
              width: 3,
            },
            data: this.getaQ(logs, 0, minTime, maxTime),

          }
        }),
        // {
        //     name : '产品新增数量',
        //     type : 'bar',
        //     yAxisIndex : 1,
        //     data :this.getPower(logs, 0, minTime, maxTime),
        //   },

      ],
    }
  }

  private getPower(logs: any[], baseVal: number, minTime: any, maxTime: any) {
    let logResult:any = []
    for (let index:any = 0; index < logs.length; index++) {
      logResult.push([logs[index].time, Number(logs[index].aW), logs[index]])
      // logResult.push([logs[index].time, Number(logs[index].power), logs[index]])

    }
    // console.log('logResult' + logResult)
    return logResult
  }
  private getaQ(logs: any[], baseVal: number, minTime: any, maxTime: any) {
    let logResult:any = []
    for (let index:any = 0; index < logs.length; index++) {
      // logResult.push([logs[index].time, Number(logs[index].power), logs[index]])

      logResult.push([logs[index].time, Number(logs[index].aQ), logs[index]])
    }
    // console.log(logResult)
    return logResult
  }

  private getAddrPower(data: any, index: any) {
    var allList = []
    var addrLength = 0
    for (var mac in data) {
      var timeContent = data[mac]
      for (var k in timeContent) {
        var a = timeContent[k]
        // console.log('a' + a.length)
        addrLength = a.length
        for (var v in a) {
          // console.log('时间' + k + '线路' + a[v]['addr'] + '电流' + a[v]['currentValue'] + '电压' + a[v]['voltage'])
          var obj = {
            time: k,
            addr: a[v]['addr'],
            currentValue: a[v]['currentValue'],
            voltage: a[v]['voltage'],
            power: a[v]['currentValue'] * a[v]['voltage'],
          }
          allList.push(obj)
        }
      }
    }
    let allObj = new Map()
    for (let i = 0; i < addrLength; i++) {
      var lists = []
      for (let index = 0; index < allList.length; index++) {
        const element = allList[index]
        // console.log('element' + JSON.stringify(element))
        if (element.addr === i) {
          var obj1 = {
            time: element.time,
            power: element.power,
          }
          lists.push(obj1)
        }
      }
      allObj.set(i, lists)
    }
    console.log('allObj' + allObj)
    for (let item of allObj) {
      console.log('item' + JSON.stringify(item))
    }
    // var timeList: any = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
    // for (let index = 0; index < timeList.length; index++) {
    //   const element = timeList[index]
    // }
    var logResult: any
    if (index === 1) {
      logResult = [210, 120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90, 224]
    }
    if (index === 2) {
      logResult = [120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90, 230, 210, 120, 132, 99]
    }
    if (index === 3) {
      logResult = [120, 132, 101, 134, 90, 230, 134, 90, 230, 210, 120, 132, 101, 210, 120, 132, 101, 134, 90, 230, 210, 120, 132, 180]
    }
    return logResult
  }
  private getEledev() {
    let that = this
    const orgId = UserModule.orgInfo.orgId
    api.getElectricInfo({ orgId }).then((res) => {
      let arr = []
      console.log(res);
    

      for (let i in res) {
        console.log(i)
          let obj = {
        label: '',
        value: '',

      }
      let arr1 =res[i]
      obj.label = i
      for (let j=0;j<arr1.length;j++) {
        //判断是否有@1并且是最后两位
        if(arr1[j].devId.indexOf('@1')!=-1&&arr1[j].devId.slice(-2)=='@1')
        {
          obj.label = arr1[j].devName+'-'+arr1[j].devId.substring(8,12)
        }
      }
        
        // obj.label = res[i]
        obj.value = i
        arr.push(obj)
      }
      console.log(arr);
      that.queryItems[0].options = arr
    })
  }
  // this.getEledev()
}
